<template>
  <el-dialog title="修改密码" :visible.sync="updatePasswordDialog" width="800px">
    <el-form :model="updatePasswordForm" :rules="rules" ref="formRef">
      <el-row>
        <el-col :span="10">
          <el-form-item label-width="100px" label="旧密码" prop="oldPassword">
            <el-input v-model="updatePasswordForm.oldPassword" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label-width="100px" label="新密码" prop="newPassword">
            <el-input show-password v-model="updatePasswordForm.newPassword" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label-width="100px" label="确认密码" prop="agaNewPassword">
            <el-input show-password v-model="updatePasswordForm.agaNewPassword" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="updatePasswordDialog = false">取 消</el-button>
      <el-button type="danger" @click="updatePassword">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updatePassWord } from '/src/api/contacts/user'
import router from "../../../../../router";
export default {
  name: "UpdatePassword",
  data() {
    const alikeVerification = (rule, value, callback) => {
      const form = this.updatePasswordForm;
      if (form.newPassword === form.agaNewPassword){
        callback();
      }
      callback(new Error('确定密码和新密码不一致！'));
    };
    const passwordVerification = (rule, value, callback) => {
      const hasLetters = /[A-Za-z]/.test(value);
      const hasNumbers = /\d/.test(value);
      if (hasLetters && hasNumbers) {
        callback();
      } else {
        callback(new Error('密码必须同时包含字母和数字！'));
      }
    };
    return {
      updatePasswordForm:{
        oldPassword:"",
        newPassword:"",
        agaNewPassword:""
      },
      rules: {
        oldPassword: [{required: true, message: "请输入旧密码！", trigger: "blur"}],
        newPassword:[{required: true, message: "请输入新密码！", trigger: "blur"},
          { min: 6, max: 15, message: '密码长度需在6-15位之间', trigger: 'blur' },
          { validator: passwordVerification, message: '密码必须同时包含字母和数字！', trigger: 'blur' }],
        agaNewPassword: [{required: true, message: "请输入确认密码！", trigger: "blur"},{ validator: alikeVerification, trigger: 'blur' }]
      },
      updatePasswordDialog:false
    }
  },
  methods:{
    updatePassword(){
      this.$refs.formRef.validate((valid) => {
        if (!valid){return};
        updatePassWord(this.updatePasswordForm).then(val=>{
          if (val.status == 200 && val.data.code == 200){
            this.$notify.success({title: '提示', message: '密码修改成功，请重新登录！', offset: 40});
            localStorage.removeItem("user");
            router.replace('/login');
          }else {
            this.$notify.error({title: '提示', message:val.data.message, offset: 40})
          }
        })
        console.log(valid)
      });
    },
    openDialog(){
      this.updatePasswordDialog = true;
    }
  }
}
</script>

<style scoped>

</style>